import { createContext, useContext } from 'react'
import { type MenuAnalyticsLayoutStore } from '../store/menuAnalyticsLayoutStore'

export const MenuAnalyticsLayoutContext = createContext<MenuAnalyticsLayoutStore | null>(null)

export const useMenuAnalyticsLayoutContext = () => {
  const context = useContext(MenuAnalyticsLayoutContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with MenuAnalyticsLayoutContext'
    )

  return context
}
